export const formatTimestamp = (
  value: string | null | undefined
): string | null => {
  if (!value) return null;
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Time of day only: 3:45 PM. For disambiguating two rows that fall on the same
// calendar day, where formatTimestamp's day granularity is not enough.
export const formatTimeOfDay = (
  value: string | null | undefined
): string | null => {
  if (!value) return null;
  return new Date(value).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
};

// Short date for table cells: 1/15/25
export const formatTableDate = (value: string | null | undefined): string => {
  if (!value) return '-';
  return new Date(value).toLocaleDateString('en-US', {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
  });
};

// Locale-aware date + time for activity feeds: 6/19/25 • 3:45 PM
export const formatActivityDate = (
  dateString: string,
  locale: string
): string => {
  const date = new Date(dateString);
  const datePart = date.toLocaleDateString(locale, {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  });
  const timePart = date.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${datePart} • ${timePart}`;
};
